export default "__VITE_ASSET__63258d80__"